import { NgModule } from '@angular/core';
import { LeavePageService } from '@app/core/leave-page-handler/service/leave-page.service';
import { ActivityTypeDataService } from '@app/pcs/services/activity-type-data.service';
import { AdvancedSearchDataService } from '@app/pcs/services/advanced-search-data.service';
import { AdvancedSearchRequiredFieldsService } from '@app/pcs/services/advanced-search-required-fields.service';
import { AgencyService } from '@app/pcs/services/agency.service';
import { AgencyDataService } from '@app/pcs/services/agency-data.service';
import { BulkExportDataService } from '@app/pcs/services/bulk-export-data.service';
import { CalendarEditService } from '@app/pcs/services/calendar-edit.service';
import { CalendarRestService } from '@app/pcs/services/calendar-rest.service';
import { CountryDataService } from '@app/pcs/services/country-data.service';
import { DictionaryRestService } from '@app/pcs/services/dictionary-rest.service';
import { DossierSearchGridService } from '@app/pcs/services/dossier-search-grid.service';
import { DossierSearchGridColumnsService } from '@app/pcs/services/dossier-search-grid-columns.service';
import { DossierStatusDataService } from '@app/pcs/services/dossier-status-data.service';
import { ExportSearchResultsReportService } from '@app/pcs/services/export-search-results-report.service';
import { FilterService } from '@app/pcs/services/filter.service';
import { FilterDisplaySettingsService } from '@app/pcs/services/filter-display-settings.service';
import { GridService } from '@app/pcs/services/grid.service';
import { LanguageDataService } from '@app/pcs/services/language-data.service';
import { LocoTypeDataService } from '@app/pcs/services/loco-type-data.service';
import { MarkReadStatusDataService } from '@app/pcs/services/mark-read-status-data.service';
import { OperationPointDataService } from '@app/pcs/services/operation-point-data.service';
import { SearchCriteriaService } from '@app/pcs/services/search-criteria.service';
import { TimetablePeriodsService } from '@app/pcs/services/timetable-periods.service';
import { TrafficPeriodDataService } from '@app/pcs/services/traffic-period-data.service';
import { TrainParametersService } from '@app/pcs/services/train-parameters.service';
import { TrainParametersTemplateDataService } from '@app/pcs/services/train-parameters-template-data.service';
import { TrainTypeService } from '@app/pcs/services/train-type.service';
import { UserFilterDataService } from '@app/pcs/services/user-filter-data.service';
import { UserGridConfigurationService } from '@app/pcs/services/user-grid-configuration.service';
import { UserGridConfigurationDataService } from '@app/pcs/services/user-grid-configuration-data.service';
import { UserLabelDataService } from '@app/pcs/services/user-label-data.service';
import { ValdrConstraintsRestService } from '@app/pcs/services/valdr-constraints-rest.service';

@NgModule({
  providers: [
    DictionaryRestService,
    ValdrConstraintsRestService,
    OperationPointDataService,
    LocoTypeDataService,
    AgencyService,
    AgencyDataService,
    LeavePageService,
    AdvancedSearchDataService,
    SearchCriteriaService,
    UserLabelDataService,
    MarkReadStatusDataService,
    UserFilterDataService,
    DossierSearchGridService,
    DossierSearchGridColumnsService,
    FilterService,
    TrafficPeriodDataService,
    BulkExportDataService,
    GridService,
    CalendarEditService,
    CalendarRestService,
    CountryDataService,
    LanguageDataService,
    ActivityTypeDataService,
    TrainTypeService,
    ExportSearchResultsReportService,
    TimetablePeriodsService,
    AdvancedSearchRequiredFieldsService,
    TrainParametersTemplateDataService,
    TrainParametersService,
    FilterDisplaySettingsService,
    UserGridConfigurationService,
    UserGridConfigurationDataService,
    DossierStatusDataService
  ]
})
export class PcsServicesModule {
}
